export default __webpack_public_path__ + "static/media/webhook-light.a07fd832.svg";